export default "__VITE_ASSET__BocyXWDs__"